import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const TitleRoot = styled(Typography)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  display: 'none',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
  },
}));

const TitleIcon = styled('span')(({ theme }) => ({
  marginRight: theme.spacing(0.5),
  display: 'inline-flex',
  alignItems: 'center',
}));

export default function MobileScreenTitle({ Icon, title }) {
  return (
    <TitleRoot variant="h4">
      {Icon && <TitleIcon as={Icon} />}
      {title}
    </TitleRoot>
  );
}
